
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 2.438C7.167 2.438 2.437 7.167 2.437 13S7.168 23.563 13 23.563 23.563 18.832 23.563 13 18.832 2.437 13 2.437zM14.793 17.3a.812.812 0 01.193.895.813.813 0 01-1.342.253L8.77 13.574a.812.812 0 010-1.148l4.875-4.875a.813.813 0 011.15 1.148L10.492 13l4.3 4.3z","fill":"#fff"}})])
          )
        }
      }
    